import axios from 'axios';
import typeToReducer from 'type-to-reducer';
import { SUCCESS, REQUEST, FAIL } from 'containers/App/configureStore';
import { url } from 'configs/';
const baseUrl = url.NEWTUBE_API_SERVER;
const path = 'tube/banner/';
const FETCH_BANNERS = `${path}FETCH_BANNERS`;

const initialState = {
  data: [],
  isLoading: true,
  isLoaded: false,
  carouselSecond: 10,
};

export default typeToReducer({
  [FETCH_BANNERS]: {
    [REQUEST]: (state) => {
      return Object.assign({}, state, { isLoading: true, isLoaded: false, data: [] });
    },
    [SUCCESS]: (state, action) => {
      return Object.assign({}, state, { isLoading: false, isLoaded: true, data: action.payload.data.data });
    },
    [FAIL]: (state) => {
      return Object.assign({}, state, { isLoading: false, isLoaded: false, data: [] });
    },
  },
}, initialState);

export function fetchBanners() {
  return {
    type: FETCH_BANNERS,
    payload: axios.get(`${baseUrl}TubeBanner`),
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/Index/reducers/bannerReducer.js
 **/